module.exports = __webpack_public_path__ + "static/media/drag-city-combined-iphonex2.01118488.png";